import { render, staticRenderFns } from "./Thank_you.vue?vue&type=template&id=edf83fb4&"
import script from "./Thank_you.vue?vue&type=script&lang=js&"
export * from "./Thank_you.vue?vue&type=script&lang=js&"
import style0 from "./Thank_you.vue?vue&type=style&index=0&id=edf83fb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports